import { RuntimeWidget } from 'client/types';
import withErrorBoundary from 'client/widget-components/components/ErrorBoundary/withErrorBoundary';
import useEditor from 'client/widget-components/customHooks/useEditor';
import React, { Suspense, lazy, useState } from 'react';
import styled from 'styled-components';
import BookingMarkup from './components/BookingMarkup';
import { customClassNames } from './utils';

const loadModule = () => import('@calcom/atoms');

const Booker = lazy(() =>
    loadModule().then((module) => ({ default: module.Booker }))
);
const CalProvider = lazy(() =>
    loadModule().then((module) => ({ default: module.CalProvider }))
);

interface CalBookingProps {
    clientId: string;
    userName: string;
    eventSlug: string;
    localeCode?: any;
    apiUrl?: string;
    teamId: number;
}
export const API_URL = 'https://api.cal.com/v2';
const DEFAULT_LOCALE = 'en';
const RuntimeCalBooking: RuntimeWidget = (props: CalBookingProps) => {
    const {
        localeCode = DEFAULT_LOCALE,
        apiUrl = API_URL,
        eventSlug,
        clientId,
        userName,
        teamId,
    } = props;

    const [editor] = useState(useEditor());

    if (!eventSlug) {
        if (editor.isInPreviewOrEditor()) {
            return <BookingMarkup />;
        }
        console.error('Booker - Event slug is required');
        return null;
    }

    return (
        <CalBookingWrapper data-auto='ssr-cal-booking-widget'>
            <div className='booker-wrapper'>
                <Suspense fallback={<div>Loading Booker...</div>}>
                    <CalProvider
                        clientId={clientId}
                        options={{ apiUrl }}
                        language={localeCode}
                    >
                        <StyledBookerWrapper>
                            <Booker
                                eventSlug={eventSlug}
                                customClassNames={customClassNames}
                                {...(teamId
                                    ? { isTeamEvent: true, teamId }
                                    : { username: userName })}
                            />
                        </StyledBookerWrapper>
                    </CalProvider>
                </Suspense>
            </div>
        </CalBookingWrapper>
    );
};
const StyledBookerWrapper = styled.div<{
    isHidden?: boolean;
}>`
    display: ${(props) => (props.isHidden ? 'none' : 'block')};
`;

const CalBookingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    --booker-meta-width: 120px;
    .booker-wrapper {
        width: 100%;
        .calcom-atoms {
            .available-time-slots-header-container {
                display: flex;
                flex-wrap: wrap;
            }
            .booker-container {
                display: flex;
                box-sizing: border-box;
                > * {
                    width: auto;
                    flex: 1;
                }
                .event-meta-title {
                    font-size: x-large !important;
                }
            }
        }
    }
`;

export default withErrorBoundary({
    Comp: RuntimeCalBooking,
    logProps: true,
    componentName: 'CalBooking',
    additionalInfoToLog: {
        tag: 'booking',
    },
});
